import React from 'react';
import { Col, Row } from 'antd';
import TooltipTrimmed from '../Tooltip/TooltipTrimmed';

export default function InfoItem({ label, value, labelSpan = 9, valueSpan = 15, className = 'mt-1 mb-2', isTrimmed, maxLength, notTrimXs }) {
  return (
    <Row type="flex" align="middle" className={className}>
      <Col xs={24} sm={labelSpan} className="fw-600 text-right-upsm pr-1">{label}:</Col>
      <Col xs={24} sm={valueSpan} className="text-center-xs">
        {(value && isTrimmed) ?
          <TooltipTrimmed str={value} maxLength={maxLength} notXs={notTrimXs} /> :
          value
        }
      </Col>
    </Row>
  );
}



// WEBPACK FOOTER //
// ./src/components/InfoItem/index.js